export const base64ToUtf8 = (base64: string): string => {
  const binary = atob(base64); // Base64 → binary string
  const utf8 = decodeURIComponent(
    Array.from(binary)
      .map((char) => '%' + char.charCodeAt(0).toString(16).padStart(2, '0'))
      .join(''),
  );
  return utf8;
};
